import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "sf-widget" }
const _hoisted_2 = { class: "sf-title" }
const _hoisted_3 = { class: "sf-filtersContainer" }
const _hoisted_4 = { class: "sf-f1" }
const _hoisted_5 = { class: "sf-f2" }
const _hoisted_6 = { class: "sf-f3" }
const _hoisted_7 = { class: "sf-f4" }
const _hoisted_8 = { class: "sf-f5" }
const _hoisted_9 = { class: "sf-f6" }
const _hoisted_10 = { class: "sf-f7" }
const _hoisted_11 = { class: "sf-f8" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "sf-refoundInfo" }
const _hoisted_14 = { class: "sf-mortgageCheckBtnContainer" }
const _hoisted_15 = {
  key: 0,
  class: "lds-facebook"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 0,
  class: "sf-resultArea"
}
const _hoisted_22 = { class: "sf-buttonCheckContainer" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 0,
  class: "sf-modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_ComboInputSlider = _resolveComponent("ComboInputSlider")!
  const _component_InputNumberSimple = _resolveComponent("InputNumberSimple")!
  const _component_CompareProducts = _resolveComponent("CompareProducts")!
  const _component_ContactForm = _resolveComponent("ContactForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_InputSelect, {
            optionsData: _ctx.peopleNumberOptions,
            default: 1,
            description: _ctx.labelPeopleNumber,
            tooltipDescription: _ctx.tooltipPeopleNumber,
            onChangedVal: _ctx.changedPeopleNumberVal,
            class: "people"
          }, null, 8, ["optionsData", "description", "tooltipDescription", "onChangedVal"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_InputSelect, {
            optionsData: _ctx.childrenNumberOptions,
            default: 0,
            description: _ctx.labelChildrenNumber,
            onChangedVal: _ctx.changedChildrenNumberVal,
            class: "children"
          }, null, 8, ["optionsData", "description", "onChangedVal"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createBlock(_component_ComboInputSlider, {
            inputValue: _ctx.periodVal,
            description: _ctx.labelPeriod,
            minValue: 15,
            maxValue: 35,
            step: 1,
            key: _ctx.inputForceUpdate,
            tooltipDescription: _ctx.tooltipPeriodVal,
            onChangedVal: _ctx.changedPeriodVal
          }, null, 8, ["inputValue", "description", "tooltipDescription", "onChangedVal"]))
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createBlock(_component_ComboInputSlider, {
            inputValue: _ctx.creditVal,
            description: _ctx.labelCredit,
            minValue: 100000,
            maxValue: 2000000,
            step: 50000,
            key: _ctx.inputForceUpdate,
            onChangedVal: _ctx.changedCreditVal
          }, null, 8, ["inputValue", "description", "onChangedVal"]))
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createBlock(_component_InputNumberSimple, {
            inputValue: _ctx.areaVal,
            description: _ctx.labelArea,
            key: _ctx.inputForceUpdate,
            tooltipDescription: _ctx.tooltipAreaVal,
            onChangedVal: _ctx.changedAreaVal
          }, null, 8, ["inputValue", "description", "tooltipDescription", "onChangedVal"]))
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(), _createBlock(_component_InputNumberSimple, {
            inputValue: _ctx.interestVal,
            description: _ctx.labelInterest,
            readonly: true,
            key: _ctx.inputForceUpdate
          }, null, 8, ["inputValue", "description"]))
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(), _createBlock(_component_InputNumberSimple, {
            inputValue: _ctx.incomeVal,
            description: _ctx.labelIncome,
            key: _ctx.inputForceUpdate,
            tooltipDescription: _ctx.tooltipIncome,
            onChangedVal: _ctx.changedIncomeVal
          }, null, 8, ["inputValue", "description", "tooltipDescription", "onChangedVal"]))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_InputSelect, {
            optionsData: _ctx.cityOptions,
            default: 'Gdańsk',
            description: _ctx.labelCity,
            onChangedVal: _ctx.changedCityVal,
            class: "city"
          }, null, 8, ["optionsData", "description", "onChangedVal"])
        ]),
        _createElementVNode("div", {
          class: "sf-f9",
          innerHTML: _ctx.additionalInfo
        }, null, 8, _hoisted_12)
      ]),
      _createElementVNode("div", _hoisted_13, " Kwota kredytu z dopłatą do " + _toDisplayString(_ctx.creditLimitVal) + " PLN ", 1),
      _createElementVNode("button", {
        class: "sf-mortgageCheckBtn",
        onClick: _cache[0] || (_cache[0] = (e) => _ctx.mortgageCheckClick(e))
      }, [
        _createElementVNode("div", _hoisted_14, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_19))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                innerHTML: _ctx.textCheckBtn
              }, null, 8, _hoisted_20))
        ])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createVNode(_component_CompareProducts, {
              apiData: _ctx.dataToSend,
              creditRestPeriod: _ctx.creditRestPeriod
            }, null, 8, ["apiData", "creditRestPeriod"]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", _mergeProps({
                class: "sf-buttonCheck",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showContact && _ctx.showContact(...args)))
              }, _ctx.sfConfig?.resultButtonAttrs, { innerHTML: _ctx.textResultBtn }), null, 16, _hoisted_23)
            ]),
            (_ctx.resultInfo)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "sf-resultInfo",
                  innerHTML: _ctx.resultInfo
                }, null, 8, _hoisted_24))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.modal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createVNode(_component_ContactForm, {
            "contact-title": _ctx.contactTitle,
            dataToSend: _ctx.dataToSend,
            sfConfig: _ctx.sfConfig,
            onCloseModal: _ctx.closeContact
          }, null, 8, ["contact-title", "dataToSend", "sfConfig", "onCloseModal"])
        ]))
      : _createCommentVNode("", true)
  ]))
}